/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengePrizeBody
 */
export interface ChallengePrizeBody {
    /**
     * 
     * @type {number}
     * @memberof ChallengePrizeBody
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof ChallengePrizeBody
     */
    winnerMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengePrizeBody
     */
    rewardConfigId?: string;
}

export function ChallengePrizeBodyFromJSON(json: any): ChallengePrizeBody {
    return ChallengePrizeBodyFromJSONTyped(json, false);
}

export function ChallengePrizeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengePrizeBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'winnerMessage': !exists(json, 'winnerMessage') ? undefined : json['winnerMessage'],
        'rewardConfigId': !exists(json, 'rewardConfigId') ? undefined : json['rewardConfigId'],
    };
}

export function ChallengePrizeBodyToJSON(value?: ChallengePrizeBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantity': value.quantity,
        'winnerMessage': value.winnerMessage,
        'rewardConfigId': value.rewardConfigId,
    };
}


